import { combineReducers } from "redux";
import { reducer as ReduxFormReducer } from "redux-form";
import AuthReducer from "./AuthReducer";
import GlobalReducer from "./GlobalReducer";
import BrandReducer from "./BrandReducer";
import UserReducer from "./UserReducer";
import LogisticReducer from './LogisticReducer';
import fabricQualitiesReducer from './FabricQualitiesReducer';
import liveQualitiesReducer from './LiveRatesReducer';
import inventoryReducer from "./InventoryReducer";
import IssuePanelReducer from "./IssuePanelReducer";
import MarketingNewsReducer from "./MarketingNewsReducer";
import DiscountCouponReducer from "./DiscountCouponReducer";

export default combineReducers({
  global: GlobalReducer,
  auth: AuthReducer,
  form: ReduxFormReducer,
  brands: BrandReducer,
  logisticsPartner: LogisticReducer,
  user: UserReducer,
  fabricQualities: fabricQualitiesReducer,
  liveQualities: liveQualitiesReducer,
  inventoryData: inventoryReducer,
  issuePanelData: IssuePanelReducer,
  newsData: MarketingNewsReducer,
  coupons: DiscountCouponReducer
});
